import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, finalize, Subject, takeUntil, timeout } from 'rxjs';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { ModalService } from '../../../services/modal.service';
import { SenderService } from '../../../services/sender.service';
import { InterfaceService } from '../../../services/interface.service';
import { LeadsService } from '../../../modules/leads/services/leads.service';
import { LeadTask } from '../../../types/lead.type';

@Component({
  selector: 'app-leads-scan-tasks-list',
  templateUrl: './leads-scan-tasks-list.component.html',
  styleUrls: ['./leads-scan-tasks-list.component.scss']
})
export class LeadsScanTasksListComponent implements  OnDestroy, OnInit {
  public isLoadError$: BehaviorSubject<false | Error> = new BehaviorSubject(false);
  private destroy$: Subject<void> = new Subject();
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  get tableHeight(): number {
    return window.innerHeight - 120;
  }

  constructor(
    private snotifyService: SnotifyService,
    public modalService: ModalService,
    public senderService: SenderService,
    private interfaceService: InterfaceService,
    public leadsService: LeadsService
  ) {
  }

  ngOnInit(): void {
    this.load();
    this.leadsService.reloadScanTasks$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.load();
      });
  }

  load(isLoading = true) {
    this.isLoading$.next(isLoading);
    this.isLoadError$.next(false);
    const accountId = this.senderService.account$.value.id;
    this.leadsService.getLeadsTasks(accountId).pipe(
      takeUntil(this.destroy$),
      timeout(10000),
      finalize(() => {
        this.isLoading$.next(false);
      })
    )
      .subscribe((res) => {
        this.leadsService.leadTasks$.next(res);
      }, e => {
        this.isLoadError$.next(e);
        this.isLoading$.next(false);
      });
  }

  edit(data: LeadTask) {
    this.leadsService.editLeadTask$.next(data);
    this.modalService.openModal('LeadsScanTasksEditModalComponent', {leadTask: data});
  }

  copy(data: LeadTask) {
    this.leadsService.editLeadTask$.next(data);
    this.modalService.openModal('LeadsScanTasksEditModalComponent', {leadTask: data, copy: true});
  }
  togglePause(data: LeadTask) {
    this.leadsService.pauseLeadTask(data.id, !data.pause).pipe()
      .subscribe((res) => {
        this.load(false);
      }, error => {
        this.interfaceService.errorHandling(error, true);
      });
  }
  add() {
    this.leadsService.editLeadTask$.next();
    this.modalService.openModal('LeadsScanTasksEditModalComponent', {leadTask: false});
  }

  delete(item: LeadTask) {
    this.snotifyService.clear();
    this.snotifyService.confirm(
      (item?.name),
      'Удалить задание?',
      {
        timeout: 30000,
        titleMaxLength: 100,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Нет'
          },
          {
            text: 'Удалить',
            action: () => {
              this.leadsService.deleteLeadTask(item.id).pipe()
                .subscribe((res) => {
                  this.leadsService.leadTasks$.next(this.leadsService.leadTasks$.value.filter((v) => v.id !== item.id));
                }, error => {
                  this.interfaceService.errorHandling(error, true);
                });
            },
            bold: false
          }
        ]
      }
    );
  }


  deletePreset(item: LeadTask) {
    this.snotifyService.clear();
    this.snotifyService.confirm(
      (item?.name),
      'Отписаться от пресета?',
      {
        timeout: 30000,
        titleMaxLength: 100,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Нет'
          },
          {
            text: 'Отписаться',
            action: () => {
              const accountId = this.senderService.account$.value.id;
              this.leadsService.deletePreset(item.id, accountId).pipe()
                .subscribe((res) => {
                  this.leadsService.leadTasks$.next(this.leadsService.leadTasks$.value.filter((v) => v.id !== item.id));
                }, error => {
                  this.interfaceService.errorHandling(error, true);
                });
            },
            bold: false
          }
        ]
      }
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
